import StyledModal from "@/components/globalModal/StyledModal";
import MailUs from "@/services/support/action-items/MailUs";
import RaiseTicket from "@/services/support/action-items/RaiseTicket";
import { Box, Popover } from "@mui/material";
import HelpCentreHome from "./components/HelpCentreHome";
import {
  HELP_CENTRE_MAIL_US_TITLE,
  HELP_CENTRE_PANEL_PADDING,
  HELP_CENTRE_PANEL_WIDTH,
  HELP_CENTRE_RAISE_TICKET_TITLE,
  HELP_CENTRE_RAISE_TICKET_WIDTH,
  HELP_CENTRE_SECTION,
  SUPPORT_EMAIL,
} from "./help-center-constant";
import { HelpCentreSection } from "./help-center-types";
import { useHelpCenterSection } from "./hooks/use-help-center-section";

export interface HelpCenterModalProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
}

const HelpCenterModal = ({ open, anchorEl, onClose }: HelpCenterModalProps) => {
  const { section, selectSection, resetSection } = useHelpCenterSection();

  /** the panel is an anchored popover, so it closes before a section modal opens */
  const handleSectionSelect = (nextSection: HelpCentreSection) => {
    selectSection(nextSection);
    onClose();
  };

  return (
    <>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        slotProps={{
          paper: { sx: { width: HELP_CENTRE_PANEL_WIDTH } },
        }}
      >
        <HelpCentreHome
          onSectionSelect={handleSectionSelect}
          sx={{ p: HELP_CENTRE_PANEL_PADDING }}
        />
      </Popover>

      <StyledModal
        open={section === HELP_CENTRE_SECTION.RAISE_TICKET}
        onClose={resetSection}
        dialogTitle={HELP_CENTRE_RAISE_TICKET_TITLE}
        sx={{
          "& .MuiDialog-paper": {
            width: HELP_CENTRE_RAISE_TICKET_WIDTH,
          },
        }}
      >
        <Box py={2}>
          <RaiseTicket onSuccess={resetSection} />
        </Box>
      </StyledModal>

      <StyledModal
        open={section === HELP_CENTRE_SECTION.MAIL_US}
        onClose={resetSection}
        dialogTitle={HELP_CENTRE_MAIL_US_TITLE}
        sx={{
          "& .MuiDialog-paper": {
            width: HELP_CENTRE_RAISE_TICKET_WIDTH,
          },
        }}
      >
        <Box py={2}>
          <MailUs toEmail={SUPPORT_EMAIL} onSuccess={resetSection} />
        </Box>
      </StyledModal>
    </>
  );
};

export default HelpCenterModal;
